import { apiRequest } from './axiosConfig';

export type ExternalApiTokenAbility = 'image_styles:write' | 'video_styles:write';

export interface ExternalApiToken {
  id: number;
  name: string;
  token_prefix: string;
  abilities: ExternalApiTokenAbility[];
  created_by_admin?: {
    id: number;
    name: string;
    email: string;
  } | null;
  last_used_at?: string | null;
  last_used_ip?: string | null;
  expires_at?: string | null;
  revoked_at?: string | null;
  is_active: boolean;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface ExternalApiTokenCreateRequest {
  name: string;
  abilities: ExternalApiTokenAbility[];
  expires_at?: string | null;
}

export interface ExternalApiTokenCreateResponse extends ExternalApiToken {
  plain_token: string;
}

interface TokenListResponse {
  success: boolean;
  data: ExternalApiToken[];
}

interface TokenResponse {
  success: boolean;
  data: ExternalApiToken;
}

interface TokenCreateApiResponse {
  success: boolean;
  data: ExternalApiTokenCreateResponse;
}

const adminExternalApiTokenService = {
  async getAll(): Promise<ExternalApiToken[]> {
    const response = await apiRequest.get<TokenListResponse>('admin/external-api-tokens');
    return response.data;
  },

  async create(data: ExternalApiTokenCreateRequest): Promise<ExternalApiTokenCreateResponse> {
    const response = await apiRequest.post<TokenCreateApiResponse>('admin/external-api-tokens', data);
    return response.data;
  },

  async revoke(id: number): Promise<ExternalApiToken> {
    const response = await apiRequest.put<TokenResponse>(`admin/external-api-tokens/${id}/revoke`);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiRequest.delete(`admin/external-api-tokens/${id}`);
  },
};

export default adminExternalApiTokenService;
